// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-page .timeslots {
  width: 80%;
  margin: auto;
  margin-bottom: 30px; }
  .availability-page .timeslots .buttons {
    padding: 10px;
    text-align: center;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer; }
  .availability-page .timeslots .opt-out-true {
    border: 1px solid #4330ff;
    color: #4330ff;
    text-decoration: line-through; }
  .availability-page .timeslots .opt-out-false {
    color: #ffffff;
    background-color: #4330ff; }
`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/Availability/availability.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe,EAAE;EACnB;IACE,yBAAyB;IACzB,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,cAAc;IACd,yBAAyB,EAAE","sourcesContent":[".availability-page .timeslots {\n  width: 80%;\n  margin: auto;\n  margin-bottom: 30px; }\n  .availability-page .timeslots .buttons {\n    padding: 10px;\n    text-align: center;\n    border-radius: 5px;\n    margin-bottom: 10px;\n    cursor: pointer; }\n  .availability-page .timeslots .opt-out-true {\n    border: 1px solid #4330ff;\n    color: #4330ff;\n    text-decoration: line-through; }\n  .availability-page .timeslots .opt-out-false {\n    color: #ffffff;\n    background-color: #4330ff; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
